import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import * as Icon from 'react-feather';
import { Grid } from '@material-ui/core';
import profile from '../../src/assets/images/doctor.png';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import IconButton from '@material-ui/core/IconButton';
import preval from 'preval.macro'
const styles = {
  root: {
    flexGrow: 1,
    background: "#318fa9",

  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  button: {
    color: '#B2EBF2',
    background: "#318fa9",

  }

  //# 0 d7782
};


class MenuAppBar extends React.Component {
  state = {
    auth: true,
    anchorEl: null,
    loginMenuItem: 'Logout',
  };

  toggleCustm() {
    var element = document.getElementById("side_menu");
    element.classList.toggle("mystyle");
  }

  handleChange = (event, checked) => {
    this.setState({ auth: checked });
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleLogout = async () => {
    try {
      localStorage.removeItem('profession');
      await Auth.signOut();
    }
    catch (ex) { }
    // this.props.history.push("/signout");
    //   Auth.signOut().then(() => {
    //   console.log('signedOut');
    // }).catch(err => {
    //   console.log(err);
    //   this.error(err);
    // });
    this.setState({ anchorEl: null, loginMenuItem: 'Login', });
  }

  render() {
    const { classes } = this.props;
    const { auth, anchorEl } = this.state;
    const open = Boolean(anchorEl);


    return (
      <div className={classes.root}>
        <AppBar position="sticky" className="fixed_cls">
          <Toolbar>
            <Grid container >
              <Grid item lg={12} sm={12} xs={12} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div className="app-logo2">
                  <a href="/dashboard">
                    <div className="log-img">
                      <img src="/NHRABanner.png" alt="/dashboard" title="NHRA" style={{ maxWidth: '100%' }} />
                    </div>
                  </a>
                </div>
                <div className='header_icon' id="head_icon">
                  <input className="menu-btn" type="checkbox" id="menu-btn" onClick={() => this.toggleCustm()} />
                  <label style={{ fontSize: '9px', float: 'right' }} for="">Build Date: {preval`module.exports = new Date().toLocaleString('en-US', { timeZone: 'Asia/Bahrain' });`}</label>
                </div>
              </Grid>

              {/* TODO:Next sprint  */}
              {/* <Grid item lg={6} sm={9} xs={9} style={{display:'flex',alignItems:'center',justifyContent:'flex-end',padding:5}}>
                <Button variant="outlined" style={{color:'#fff',borderColor:'#fff',fontFamily:'Josefin Sans',alignItems:'center',fontSize:12}} className="d-none d-lg-flex d-md-flex"><Icon.Clock color="#fff"/>&nbsp;&nbsp;Last logged in<br/>5 Feb,2021</Button>
                <Icon.Clock color="#fff" className="d-lg-none d-md-none d-flex"/>
                <IconButton><Icon.Bell color="#fff"/></IconButton>
                <Avatar alt="Remy Sharp" src={profile} style={{height:'40px',width:'40px'}}/>
                <Typography variant="subheading" className="text-truncate" style={{ color: '#fff',fontFamily:'Josefin Sans'}}>Welcome<br/>Ahmed Mohammad</Typography>
              </Grid> */}

            </Grid>
            {/* <div className="app-logo2">
              <a href="/dashboard">
                <div className="log-img">
                  <img src="/NHRABanner.png" alt="/dashboard" title="NHRA" />
                </div>
              </a>
            </div> */}
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

MenuAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(MenuAppBar));
